import UpdateShopArticleTaxRequestModelBase from '../_generated/modelBases/update-shop-article-tax-request-model-base';

export default class UpdateShopArticleTaxRequestModel extends UpdateShopArticleTaxRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
